module.exports = __webpack_public_path__ + "static/add2-8654b8bda4b514deb07ca5b2e26554c8.png";